
export class NavigationState {
    // API Responses


    // App models


}